<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2469"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2473"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2483"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2481" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2519"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2517" /></clipPath></defs><g
     id="g2475"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2477"><g
         id="g2479"
         clip-path="url(#clipPath2483)"><g
           id="g2485"
           transform="translate(7.5,35.5566)"><path
             d="M 0,0 H 497"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2487" /></g><g
           id="g2489"
           transform="translate(488.4678,260.0083)"><path
             d="M 0,0 V -224.452"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2491" /></g><g
           id="g2493"
           transform="translate(23.5322,35.5566)"><path
             d="M 0,0 V 224.452"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2495" /></g><g
           id="g2497"
           transform="translate(472.4355,260.0083)"><path
             d="M 0,0 H 32.064 L 0,72.145 h -160.323"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2499" /></g><g
           id="g2501"
           transform="translate(199.8872,332.1533)"><path
             d="m 0,0 h -160.323 l -32.064,-72.145 H -72.146 L 56.113,56.113 184.371,-72.145 h 56.113"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2503" /></g></g></g><g
       id="g2505"
       transform="translate(256,388.2661)"><path
         d="M 0,0 V 88.177"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path2507" /></g><g
       id="g2509"
       transform="translate(256,476.4434)"><path
         d="M 0,0 H 56.113 V -40.081 H 0"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path2511" /></g><g
       id="g2513"><g
         id="g2515"
         clip-path="url(#clipPath2519)"><g
           id="g2521"
           transform="translate(304.0967,243.9756)"><path
             d="m 0,0 c 0,-26.563 -21.534,-48.097 -48.097,-48.097 -26.563,0 -48.096,21.534 -48.096,48.097 0,26.563 21.533,48.097 48.096,48.097 C -21.534,48.097 0,26.563 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2523" /></g><g
           id="g2525"
           transform="translate(256,227.9434)"><path
             d="m 0,0 v 16.032 l 16.032,8.016"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2527" /></g><g
           id="g2529"
           transform="translate(256,139.7661)"><path
             d="M 0,0 V -72.145"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2531" /></g><g
           id="g2533"
           transform="translate(191.8711,35.5566)"><path
             d="M 0,0 V 32.064 H 128.258 V 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2535" /></g><g
           id="g2537"
           transform="translate(304.0967,67.6211)"><path
             d="M 0,0 V 72.145 H -96.193 V 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2539" /></g><g
           id="g2541"
           transform="translate(103.6948,91.6694)"><path
             d="M 0,0 H 64.128 V 48.097 H -48.098 V 0 h 16.035"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2543" /></g><path
           d="m 55.597,171.831 h 112.226 v 48.097 H 55.597 Z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2545" /><g
           id="g2547"
           transform="translate(111.7095,171.8306)"><path
             d="M 0,0 V 48.097"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2549" /></g><g
           id="g2551"
           transform="translate(111.7095,91.6694)"><path
             d="M 0,0 V 48.097"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2553" /></g><path
           d="m 344.177,91.669 h 112.226 v 48.097 H 344.177 Z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2555" /><path
           d="m 344.177,171.831 h 112.226 v 48.097 H 344.177 Z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2557" /><g
           id="g2559"
           transform="translate(400.2905,171.8306)"><path
             d="M 0,0 V 48.097"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2561" /></g><g
           id="g2563"
           transform="translate(400.2905,91.6694)"><path
             d="M 0,0 V 48.097"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2565" /></g></g></g></g></svg>
</template>
